import { createRoutine, promisifyRoutine } from 'redux-saga-routines';

// credentials
export const getCredentials = createRoutine('integrations/getCredentials');
export const getCredentialsPromiseCreator = promisifyRoutine(getCredentials);
export const patchCredentials = createRoutine('integrations/patchCredentials');
export const patchCredentialsPromiseCreator =
  promisifyRoutine(patchCredentials);



